export { default } from "./useTeacherGet";
